import { AppState } from '@/types';

export function getMonthStart(date: Date = new Date()) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

export function resetMonthlyCounters(state: AppState): AppState {
  const now = new Date();
  const currentMonthStart = getMonthStart(now);
  const lastMonthlyReset = state.monthlyStartDate ? new Date(state.monthlyStartDate) : null;
  
  // Check if it's a new month since the last reset
  const isNewMonth = !lastMonthlyReset || 
    currentMonthStart.getTime() !== getMonthStart(lastMonthlyReset).getTime();
  
  if (!isNewMonth) {
    return state; // No reset needed
  }
  
  console.log('🗓️ Monthly reset triggered - resetting monthly counters');
  
  // Reset monthly counters
  const resetState = {
    ...state,
    currentMonthPoints: 0,
    monthlyStartDate: currentMonthStart,
  };
  
  return resetState;
}

export function checkAndApplyMonthlyReset(state: AppState): AppState {
  return resetMonthlyCounters(state);
}